import { useState } from 'react';
import { Outlet, Link } from 'react-router-dom';
import { TextSignInSignUp } from '../Components/TextSignInorSignUp';
function CorporIndi() {
  const [isActive, setIsActive] = useState(false);
  const handleStyle = () => {
    // if(isActive){
    setIsActive(!isActive);
    // else if(!isActive){
    //     setIsActive(true);
    // }
  };
  const linkStyleDefault =
    'text-center py-2 px-6 font-pin rounded-md w-1/2 text flex items-center justify-center';
  const linkStyleActive = 'bg-b-mc text-p-wh font-semibold';
  return (
    <div className='py-32 max-w-4xl mx-auto'>
      <div className='flex box-border flex-col items-center gap-16 max-w-4xl py-16 mx-auto border-hf rounded-lg border-t-bk px-6'>
        <div className='text-center'>
          <h1 className='text-2xl font-pin font-semibold text-p-pin'>
            Sign Up
          </h1>
          <TextSignInSignUp
            title='Sign In'
            question='Already have an account?'
          />
        </div>
        <div className='border-2 rounded-lg w-full flex flex-row box-border'>
          <Link
            to='individual'
            className={`${linkStyleDefault} ${
              !isActive ? linkStyleActive : 'normal'
            }`}
            onClick={handleStyle}
          >
            Individual
          </Link>
          <Link
            to='corporate'
            className={`${linkStyleDefault} ${
              isActive ? linkStyleActive : 'normal'
            }`}
            onClick={handleStyle}
          >
            Corporate Individual
          </Link>
        </div>
        <Outlet />
      </div>
    </div>
  );
}
export default CorporIndi;
